export const CONTACT_EMAIL = "mr.oleski.info@gmail.com";
